import { useEffect, useState } from "react";
import { MessageCircle, Menu, X } from "lucide-react";

const NAV = [
  { label: "Process", target: "process" },
  { label: "Styled Outfits", target: "work" },
  { label: "Book Appointment", target: "book" },
];

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "border-b border-[#E5DEC9] bg-[#FDFBF7]/80 backdrop-blur-xl"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <button
          data-testid="logo-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-serif text-2xl font-bold uppercase tracking-[0.1em] text-[#8B0000]"
        >
          MRVEER.IN
        </button>

        <nav className="hidden items-center gap-10 md:flex">
          {NAV.map((item) => (
            <button
              key={item.target}
              data-testid={`nav-${item.target}`}
              onClick={() => scrollTo(item.target)}
              className="group relative text-xs font-medium uppercase tracking-[0.22em] text-[#686152] transition-colors duration-300 hover:text-[#141414]"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#C5A059] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
          <a
            data-testid="header-whatsapp-btn"
            href="https://wa.me/918801387013?text=Hello%20Manvir%2C%20I%20want%20to%20book%20a%20styling%20appointment."
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-full border border-[#C5A059]/50 px-5 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#C5A059] transition-all duration-300 hover:bg-[#C5A059] hover:text-[#0C0C0C]"
          >
            <MessageCircle size={14} />
            WhatsApp
          </a>
        </nav>

        <button
          data-testid="mobile-menu-btn"
          className="text-[#141414] md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="border-t border-[#E5DEC9] bg-[#FDFBF7]/95 px-6 py-6 backdrop-blur-xl md:hidden"
        >
          <div className="flex flex-col gap-5">
            {NAV.map((item) => (
              <button
                key={item.target}
                data-testid={`mobile-nav-${item.target}`}
                onClick={() => {
                  setOpen(false);
                  scrollTo(item.target);
                }}
                className="text-left text-sm uppercase tracking-[0.22em] text-[#686152]"
              >
                {item.label}
              </button>
            ))}
            <a
              data-testid="mobile-whatsapp-btn"
              href="https://wa.me/918801387013?text=Hello%20Manvir%2C%20I%20want%20to%20book%20a%20styling%20appointment."
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-fit items-center gap-2 rounded-full border border-[#C5A059]/50 px-5 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#C5A059]"
            >
              <MessageCircle size={14} />
              WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
